import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-157b1364"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white edit-support-cours-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-4" }
const _hoisted_5 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Titre "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_7 = {
  key: 0,
  class: "text-danger d-block mt-1"
}
const _hoisted_8 = { class: "col-md-4" }
const _hoisted_9 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Niveau "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_11 = {
  key: 0,
  class: "text-danger d-block mt-1"
}
const _hoisted_12 = { class: "col-md-4" }
const _hoisted_13 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Filière "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_15 = {
  key: 0,
  class: "text-danger d-block mt-1"
}
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-md-4" }
const _hoisted_18 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Matière "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_20 = {
  key: 0,
  class: "text-danger d-block mt-1"
}
const _hoisted_21 = { class: "col-md-4" }
const _hoisted_22 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Nombre d'heures "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_24 = {
  key: 0,
  class: "text-danger d-block mt-1"
}
const _hoisted_25 = { class: "col-md-4" }
const _hoisted_26 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Auteur", -1))
const _hoisted_28 = { class: "row" }
const _hoisted_29 = { class: "col-md-4" }
const _hoisted_30 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Fichier principal (PDF) ", -1))
const _hoisted_32 = {
  key: 0,
  class: "text-success d-block mt-1"
}
const _hoisted_33 = { class: "col-md-4" }
const _hoisted_34 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Prérequis", -1))
const _hoisted_36 = { class: "col-md-4" }
const _hoisted_37 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Description", -1))
const _hoisted_39 = { class: "row mt-4" }
const _hoisted_40 = { class: "col-md-12" }
const _hoisted_41 = { class: "form-check" }
const _hoisted_42 = ["checked"]
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label fw-semibold",
  for: "estModulaire"
}, " Ce support est modulaire (composé de plusieurs modules) ", -1))
const _hoisted_44 = {
  key: 0,
  class: "row mt-4"
}
const _hoisted_45 = { class: "col-md-12" }
const _hoisted_46 = { class: "border border-primary mb-10" }
const _hoisted_47 = { class: "row d-flex align-items-center justify-content-between fw-bold py-3 bg-primary" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-7 ps-4" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "fs-4 text-white mb-0" }, "Modules du support")
], -1))
const _hoisted_49 = { class: "col-md-5 pe-4" }
const _hoisted_50 = ["disabled"]
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-plus-circle me-1" }, null, -1))
const _hoisted_52 = { class: "p-4" }
const _hoisted_53 = { class: "row mt-3 align-items-start" }
const _hoisted_54 = { class: "col-md-3" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-2" }, [
  /*#__PURE__*/_createTextVNode(" Code "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_56 = ["onInput"]
const _hoisted_57 = {
  key: 0,
  class: "text-danger d-block mt-1"
}
const _hoisted_58 = {
  key: 0,
  class: "alert alert-danger mt-2 p-2"
}
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-triangle me-2" }, null, -1))
const _hoisted_60 = { class: "col-md-4" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-2" }, [
  /*#__PURE__*/_createTextVNode(" Titre "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1))
const _hoisted_62 = ["onInput"]
const _hoisted_63 = {
  key: 0,
  class: "text-danger d-block mt-1"
}
const _hoisted_64 = { class: "col-md-4" }
const _hoisted_65 = { class: "d-block text-black fw-semibold mb-2" }
const _hoisted_66 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_67 = ["onChange", "name"]
const _hoisted_68 = {
  key: 0,
  class: "text-success d-block mt-1"
}
const _hoisted_69 = { class: "col-md-1 d-flex align-items-start pt-4" }
const _hoisted_70 = ["onClick", "disabled"]
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete" }, null, -1))
const _hoisted_72 = [
  _hoisted_71
]
const _hoisted_73 = { class: "row mt-3" }
const _hoisted_74 = { class: "col-md-12" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-2" }, "Description du module", -1))
const _hoisted_76 = ["onInput"]
const _hoisted_77 = {
  key: 0,
  class: "my-4"
}
const _hoisted_78 = { class: "row mt-5" }
const _hoisted_79 = { class: "col-md-12" }
const _hoisted_80 = { class: "d-flex align-items-center" }
const _hoisted_81 = ["disabled"]
const _hoisted_82 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-1 position-relative top-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        ref: "supportCoursForm",
        onSubmit: _ctx.editSupportCours,
        onInvalidSubmit: _ctx.handleInvalidSubmit,
        "validation-schema": _ctx.supportCoursSchema,
        validateOnInput: false,
        validateOnMount: false,
        initialValues: {
          prerequis: _ctx.prerequis,
          nombreHeures: _ctx.nombreHeures,
          description: _ctx.description,
          titre: _ctx.titre,
          nombreModules: _ctx.nombreModules,
          estModulaire: _ctx.estModulaire,
          auteur: _ctx.auteur,
          fichier: _ctx.fichier,
          niveau: _ctx.selectedNiveau,
          filiere: _ctx.selectedFiliere,
          matiere: _ctx.selectedMatiere,
          modulesAdded: _ctx.addedModules
        }
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createVNode(_component_Field, { name: "titre" }, {
                  default: _withCtx(({ field, errorMessage }) => [
                    _createElementVNode("input", _mergeProps(field, {
                      type: "text",
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "Titre du support"
                    }), null, 16),
                    errorMessage
                      ? (_openBlock(), _createElementBlock("small", _hoisted_7, _toDisplayString(errorMessage), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createVNode(_component_Field, { name: "niveau" }, {
                  default: _withCtx(({ field, errorMessage, handleChange }) => [
                    _createVNode(_component_Multiselect, {
                      options: _ctx.globalNiveauxOptions,
                      searchable: true,
                      "track-by": "value",
                      label: "label",
                      modelValue: field.value,
                      "onUpdate:modelValue": (val) => { handleChange(val); _ctx.onGlobalNiveauChange(val); },
                      placeholder: "Sélectionner le niveau"
                    }, null, 8, ["options", "modelValue", "onUpdate:modelValue"]),
                    errorMessage
                      ? (_openBlock(), _createElementBlock("small", _hoisted_11, _toDisplayString(errorMessage), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createVNode(_component_Field, { name: "filiere" }, {
                  default: _withCtx(({ field, errorMessage, handleChange }) => [
                    _createVNode(_component_Multiselect, {
                      options: _ctx.globalFilieresOptions,
                      searchable: true,
                      "track-by": "value",
                      label: "label",
                      modelValue: field.value,
                      "onUpdate:modelValue": (val) => { handleChange(val); _ctx.onGlobalFiliereChange(val); },
                      placeholder: "Sélectionner la filière",
                      disabled: !_ctx.globalSelectedNiveau || _ctx.isLoadingFilieres
                    }, null, 8, ["options", "modelValue", "onUpdate:modelValue", "disabled"]),
                    errorMessage
                      ? (_openBlock(), _createElementBlock("small", _hoisted_15, _toDisplayString(errorMessage), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createVNode(_component_Field, { name: "matiere" }, {
                  default: _withCtx(({ field, errorMessage, handleChange }) => [
                    _createVNode(_component_Multiselect, {
                      options: _ctx.globalMatieresOptions,
                      searchable: true,
                      "track-by": "value",
                      label: "label",
                      modelValue: field.value,
                      "onUpdate:modelValue": handleChange,
                      placeholder: "Sélectionner la matière",
                      disabled: !_ctx.globalSelectedNiveau || !_ctx.globalSelectedFiliere || _ctx.isLoadingMatieres
                    }, null, 8, ["options", "modelValue", "onUpdate:modelValue", "disabled"]),
                    errorMessage
                      ? (_openBlock(), _createElementBlock("small", _hoisted_20, _toDisplayString(errorMessage), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _createVNode(_component_Field, { name: "nombreHeures" }, {
                  default: _withCtx(({ field, errorMessage }) => [
                    _createElementVNode("input", _mergeProps(field, {
                      type: "number",
                      min: "1",
                      max: "1000",
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "Ex: 60"
                    }), null, 16),
                    errorMessage
                      ? (_openBlock(), _createElementBlock("small", _hoisted_24, _toDisplayString(errorMessage), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _hoisted_27,
                _createVNode(_component_Field, { name: "auteur" }, {
                  default: _withCtx(({ field }) => [
                    _createElementVNode("input", _mergeProps(field, {
                      type: "text",
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "Nom de l'auteur (facultatif)"
                    }), null, 16)
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _hoisted_31,
                _createElementVNode("input", {
                  type: "file",
                  accept: "application/pdf",
                  onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onSupportFichierChange && _ctx.onSupportFichierChange(...args))),
                  class: "form-control shadow-none fs-md-15 text-black"
                }, null, 32),
                (_ctx.supportFichierName)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_32, " Fichier actuel: " + _toDisplayString(_ctx.supportFichierName), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _hoisted_35,
                _createVNode(_component_Field, { name: "prerequis" }, {
                  default: _withCtx(({ field }) => [
                    _createElementVNode("textarea", _mergeProps(field, {
                      rows: "4",
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "Connaissances requises pour ce cours..."
                    }), null, 16)
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _hoisted_38,
                _createVNode(_component_Field, { name: "description" }, {
                  default: _withCtx(({ field }) => [
                    _createElementVNode("textarea", _mergeProps(field, {
                      rows: "4",
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "Description détaillée du support de cours..."
                    }), null, 16)
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _createVNode(_component_Field, {
                  name: "estModulaire",
                  type: "checkbox"
                }, {
                  default: _withCtx(({ field }) => [
                    _createElementVNode("input", _mergeProps(field, {
                      type: "checkbox",
                      id: "estModulaire",
                      class: "form-check-input",
                      checked: field.value,
                      onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onEstModulaireChange && _ctx.onEstModulaireChange(...args)))
                    }), null, 16, _hoisted_42)
                  ]),
                  _: 1
                }),
                _hoisted_43
              ])
            ])
          ]),
          (_ctx.estModulaire)
            ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("div", _hoisted_46, [
                    _createElementVNode("div", _hoisted_47, [
                      _hoisted_48,
                      _createElementVNode("div", _hoisted_49, [
                        _createElementVNode("button", {
                          class: "btn btn-success float-end",
                          type: "button",
                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addNewModule && _ctx.addNewModule(...args))),
                          disabled: !_ctx.isLastModuleComplete || _ctx.hasModuleCodeDuplicates
                        }, [
                          _hoisted_51,
                          _createTextVNode(" Ajouter un module ")
                        ], 8, _hoisted_50)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_52, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleModules, (module, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: module.tempId || module.id
                        }, [
                          _createElementVNode("div", _hoisted_53, [
                            _createElementVNode("div", _hoisted_54, [
                              _hoisted_55,
                              _createVNode(_component_Field, {
                                name: `modulesAdded[${_ctx.visibleIndex(module)}].code`
                              }, {
                                default: _withCtx(({ field, errorMessage }) => [
                                  _createElementVNode("input", _mergeProps({ ref_for: true }, field, {
                                    type: "text",
                                    class: "form-control shadow-none text-black",
                                    placeholder: "Ex: MOD-001",
                                    maxlength: "50",
                                    onInput: (e) => _ctx.onModuleCodeChange(module, e)
                                  }), null, 16, _hoisted_56),
                                  errorMessage
                                    ? (_openBlock(), _createElementBlock("small", _hoisted_57, _toDisplayString(errorMessage), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1032, ["name"]),
                              (_ctx.getModuleCodeDuplicate(module.tempId, module.id))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                    _hoisted_59,
                                    _createTextVNode(" Ce code est déjà utilisé ")
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_60, [
                              _hoisted_61,
                              _createVNode(_component_Field, {
                                name: `modulesAdded[${_ctx.visibleIndex(module)}].titre`
                              }, {
                                default: _withCtx(({ field, errorMessage }) => [
                                  _createElementVNode("input", _mergeProps({ ref_for: true }, field, {
                                    type: "text",
                                    class: "form-control shadow-none text-black",
                                    placeholder: "Titre du module",
                                    maxlength: "200",
                                    onInput: (e) => _ctx.onModuleTitreChange(module, e)
                                  }), null, 16, _hoisted_62),
                                  errorMessage
                                    ? (_openBlock(), _createElementBlock("small", _hoisted_63, _toDisplayString(errorMessage), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1032, ["name"])
                            ]),
                            _createElementVNode("div", _hoisted_64, [
                              _createElementVNode("label", _hoisted_65, [
                                _createTextVNode(" Fichier du module (PDF) "),
                                (!module.id)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_66, "*"))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("input", {
                                type: "file",
                                accept: "application/pdf",
                                class: "form-control shadow-none text-black",
                                onChange: (e) => _ctx.onModuleFichierUpload(module, e),
                                name: `moduleFichier_${index}`
                              }, null, 40, _hoisted_67),
                              _createVNode(_component_Field, {
                                name: `modulesAdded[${_ctx.visibleIndex(module)}].fichierFile`,
                                modelValue: module.fichierFile,
                                "onUpdate:modelValue": ($event: any) => ((module.fichierFile) = $event),
                                style: {"display":"none"}
                              }, null, 8, ["name", "modelValue", "onUpdate:modelValue"]),
                              (module.fichierName)
                                ? (_openBlock(), _createElementBlock("small", _hoisted_68, " Fichier: " + _toDisplayString(module.fichierName), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_69, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-danger btn-sm",
                                onClick: ($event: any) => (_ctx.removeModule(module)),
                                disabled: _ctx.visibleModules.length === 1
                              }, _hoisted_72, 8, _hoisted_70)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_73, [
                            _createElementVNode("div", _hoisted_74, [
                              _hoisted_75,
                              _createVNode(_component_Field, {
                                name: `modulesAdded[${_ctx.visibleIndex(module)}].description`
                              }, {
                                default: _withCtx(({ field }) => [
                                  _createElementVNode("textarea", _mergeProps({ ref_for: true }, field, {
                                    class: "form-control shadow-none text-black",
                                    rows: "3",
                                    placeholder: "Description du module",
                                    onInput: (e) => _ctx.onModuleDescriptionChange(module, e)
                                  }), null, 16, _hoisted_76)
                                ]),
                                _: 2
                              }, 1032, ["name"])
                            ])
                          ]),
                          (index < _ctx.visibleModules.length - 1)
                            ? (_openBlock(), _createElementBlock("hr", _hoisted_77))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_78, [
            _createElementVNode("div", _hoisted_79, [
              _createElementVNode("div", _hoisted_80, [
                _createElementVNode("button", {
                  class: "default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 rounded-1 fs-md-15 fs-lg-16 bg-success",
                  type: "submit",
                  disabled: _ctx.isSubmitting || _ctx.hasModuleCodeDuplicates
                }, [
                  (_ctx.isSubmitting)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_82))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(_ctx.isSubmitting ? 'Modification en cours...' : 'Modifier le support de cours'), 1)
                ], 8, _hoisted_81),
                _createVNode(_component_router_link, {
                  to: "/liste-support",
                  class: "btn btn-danger transition border-0 lh-1 fw-medium"
                }, {
                  default: _withCtx(() => [
                    _hoisted_83,
                    _createTextVNode(" Annuler ")
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "onInvalidSubmit", "validation-schema", "initialValues"])
    ])
  ]))
}